import React, { Component } from 'react'
import { Form, Icon } from 'semantic-ui-react'
import Dropzone from 'react-dropzone'

import './FileInput.css'

class FileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: []
    };
    this.handleProcessFile = this.handleProcessFile.bind(this);
  }

  handleProcessFile(e) {
    this.props.handleProcessFile();
  }

  onDrop(files) {
    this.setState({
      files
    });

    if (!files[0]) this.setState({disabled: true});
    if(this.props.id) {
      this.props.handleFileChange(files[0], this.props.id);
    } else {
      this.props.handleFileChange(files[0]);
    }

  }

  render() {
    return (
      <div>
        <Form>
          <Form.Field>
            <div className={this.props.error ? 'dropzone error-dropzone' : 'dropzone students-dropzone'}>
              <Dropzone
                onDrop={this.onDrop.bind(this)}
              >
                <Icon size='huge' name='file excel outline' className='upload-icon'/>
                <p>Drop or click to select files to upload.</p>
              </Dropzone>
              {
                this.state.files.length !== 0 ?
                <strong>
                    {
                      this.state.files[0].name
                    }
                </strong>
                :
                null
              }
            </div>
          </Form.Field>
        </Form>
      </div>
    );
  }
}

export default FileInput;
